import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { CUSTOMER_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getCustomerBlockadeRegistriesAction = createAsyncThunk(
    'customer/getCustomerBlockadeRegistriesAction',
    async (customerId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ CUSTOMER_PATH }/${ customerId }/blockade-registries`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCustomerBlockadeRegistriesSlice = createSlice({
    name: 'getCustomerBlockadeRegistriesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCustomerBlockadeRegistriesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCustomerBlockadeRegistriesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCustomerBlockadeRegistriesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getCustomerBlockadeRegistriesState = (state) => state.customer.getCustomerBlockadeRegistries;
export default getCustomerBlockadeRegistriesSlice.reducer;